import React, { Component } from 'react';
import api from '../../services/api';
import './DetalheFolha.css';
import '../FormatNumero/FormatCurrency';
import Menu from '../menu/Menu';
import Cookies from 'universal-cookie';
import currencyFormatter from '../FormatNumero/FormatCurrency';

export default class DetalheFolha extends Component {

    state = {
        _Detalhe: [],
        _Totais: [],
        ckCPF: '',
        _Process: '',
        _Compet: '',
    }

    async componentDidMount() {
        const cookies = new Cookies();
        this.state.ckCPF = cookies.get('ckCPF')
        console.log(this.state.ckCPF)
        const { competencia } = this.props.match.params;
        this.state._Compet = String(competencia).substr(1,10);
        this.state._Process = String(competencia).substr(12,12);
        console.log(this.state._Compet); 
        console.log(this.state._Process);
        const response = await api.get(`/datasnap/rest/tsm/RecOlerite("${this.state.ckCPF}","${this.state._Compet}", "${this.state._Process}")`);
        this.setState({ _Detalhe: response.data.result[0] });
        console.log(response.data.result[0]);
        const resp = await api.get(`/datasnap/rest/tsm/RecFolha("${this.state.ckCPF}","${this.state._Compet}", "${this.state._Process}")`);
        this.setState({ _Totais: resp.data.result[0] });
        console.log(resp.data.result[0]);
    }
    render() {

        return (
            <div className="principal">
                <div className="ListDetalhe">
                    <Menu />
                    <p></p>
                    <div>
                        <div className="sleft"><a href="/HOn/ListaFolha" className="btn btn-secondary btn-sm active" role="button" aria-pressed="true">Voltar</a></div>
                        
                        <h2>Detalhe da Folha de Pagto.</h2>
                    </div>
                    
                    <table className="table table-hover table-striped table-dark">
                        <thead>
                            <tr>
                                {/* {"I_EMPREGADOS":"213","CODI_EMP":"2","DATA":"01/09/2020","i_eventos":"1","nome_evento":"HORAS NORMAIS","TIPO_PROCES":"11","PROV_DESC":"P","VALOR_INF":"220","valor":"5179,77","nome_empr":"JOSE CARLOS SILVA TIBURCIO","i_depto":"300","i_cargos":"36","i_filiais":"1","nome_cargo":"GERENTE TECNOL. INFORMAÇAO","cbo_2002":"142515","admissao":"01/03/2013"} */}
                                <th scope="col">Cód. </th>
                                <th scope="col">Descrição</th>
                                <th scope="col">Valor R$</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state._Detalhe.map(Detalhe => (
                                <tr key={Detalhe.i_eventos}>
                                    <td>{Detalhe.i_eventos}</td>
                                    <td>{Detalhe.nome_evento}</td>
                                    <td>{currencyFormatter(parseFloat(Detalhe.valor))}</td> 
                                    {/* <td>{currencyFormatter(parseFloat(Detalhe.valor))}</td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {this.state._Totais.map(Totais => (
                        <div key={Totais.PROVENTOS} className="totais" >
                            <div className="sleft">  Vencim.: {currencyFormatter(parseFloat(Totais.PROVENTOS))} </div>
                            <div className="sCenter">  Descontos: {currencyFormatter(parseFloat(Totais.DESCONTOS))} </div>
                            <div className="sRigth">  Total Saldo: {currencyFormatter(parseFloat(Totais.PROVENTOS) - parseFloat(Totais.DESCONTOS))} </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }
}